export default "__VITE_ASSET__CkddpzKF__"